import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { BackendContext } from "../../services/backend-context";
import { User } from "../../types/types";
import styles from "./RegisterView.module.css"

export function RegisterView() {
    const [qr, setQR] = useState<User | null>(null);

    const backendConfig = useContext(BackendContext);
    const generateUser = async () => {
        const user = await fetch(`${backendConfig.backend}/users`, {
            method: "POST",
            body: ""
        }).then(resp => resp.json());
        setQR(user)
    }
    return (
        <div className={ styles.container }>
            <div className={ styles.modal }>
                <h1>Register</h1>
                { !qr && (
                    <>
                        <p>Click this button. Yep. That's it. No email address, zip code or credit card number</p>
                        <button onClick={ generateUser }>Create an account</button>
                    </>
                )}
                { qr && (
                    <>
                        <div className={ styles.qrLabel }>
                            <img src={ `${backendConfig.backend}/users/${qr.userId}/qr` } alt={ qr.userId } />
                            <div>
                                <p>
                                    You can use this QR code to access your notes. Screenshot it or save it as an image.</p>
                                <p>
                                    Alternatively, copy the code 
                                    &nbsp;<code>{ qr.userId }</code>&nbsp;
                                    and save it somewhere safe
                                </p>
                                
                            </div>
                        </div>
                    </>
                )}
                <Link to="/sign-in" className={ styles.signIn }>Sign In</Link>
            </div>
        </div>
    )
}